export default "__VITE_ASSET__CoQAk40U__"